import { PersonalInfoComponent } from './components/personal-info/personal-info.component';
import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import * as comps from "./components";
import { MemberappRoutingModule } from "./memberapp-routing.module";
import { ReactiveFormsModule, FormsModule } from "@angular/forms";
import { SharedModule } from "../shared/shared.module";
import { CoreModule } from "../core/core.module";
import { MaterialModule } from "../shared/material.module";
import { HTTP_INTERCEPTORS } from "@angular/common/http";
import { MemberAppDomService, MemberAppDataService } from "./services";
import { AcepHttpInterceptor } from "../core/interceptors/acep-http.interceptor";
import { PaymentModule } from "@acepteam/payment";
import { RetiredComponent } from './components/retired/retired.component';
import { ChapterLobbyComponent } from './components/chapter-lobby/chapter-lobby.component';





@NgModule({
  declarations: [
    comps.DummyComponent, //this has to be the first decalration..wierd behaviour ...teh component decalred first is not loading material styles..MB 2/11/2020
    comps.PersonalInfoComponent,
    comps.MembershipComponent,
    comps.EducationComponent,
    comps.NavigationComponent,
    comps.MemberappBaseComponent,
    comps.NotifyComponent,
    comps.SectionsComponent,
    comps.ChaptersComponent,
    comps.CheckoutComponent,
    comps.ChangeAddressComponent,
    comps.RetiredComponent,


    comps.CommonBaseComponent,
    comps.AddressComponent,
    comps.AccountLookupComponent,
    comps.AccountLookupMatComponent,
    comps.EducationChildComponent,
    comps.GradDateComponent,
    RetiredComponent,
    ChapterLobbyComponent


  ],
  imports: [
    ReactiveFormsModule,
    FormsModule,
    CoreModule,
    SharedModule,
    PaymentModule,
    MaterialModule,
    MemberappRoutingModule
  ],
  providers: [
    { provide: HTTP_INTERCEPTORS, useClass: AcepHttpInterceptor, multi: true }
  ],
  exports: [comps.NavigationComponent]
})
export class MemberappModule { }
